// @ts-check
import required from 'utils/required';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

/**
 * @param {{name: string, [x: string]: any}} params
 */
export function showModal(params) {
  const { name = required('name'), ...rest } = params;
  return {
    type: SHOW_MODAL,
    name,
    ...rest,
  };
}

export function hideModal() {
  return {
    type: HIDE_MODAL,
  };
}
